'use client';

import { useSyncExternalStore } from 'react';

import { getFreestarPathname, normalizeFreestarPathname, subscribeFreestarPathname } from './freestarPathnameStore';

/**
 * Pathname for Freestar channel/SPA sync — works on App Router and Pages Router
 * without importing `next/navigation` (which crashes on money Pages Router).
 */
export const useFreestarPathname = (override?: string): string => {
  const pathname = useSyncExternalStore(subscribeFreestarPathname, getFreestarPathname, () => '');

  if (override !== undefined) {
    return normalizeFreestarPathname(override);
  }
  return pathname;
};
